module.exports = __webpack_public_path__ + "img/maker_card.988c0d56.png";